// extracted by mini-css-extract-plugin
module.exports = {"wrap":"kd","title":"ld"};